export default __webpack_public_path__ + "static/media/logo-header.e05b732d.png";